// src/context/EpocasContext.js
// Gere as épocas disponíveis e a época selecionada em todo o website.
// O AuthContext utiliza epocaSelecionada para calcular as permissões por época.
import React, { createContext, useContext, useEffect, useState } from 'react';
import supabase from '../services/SupabaseService';

const EpocasContext = createContext(null);
const CHAVE_EPOCA = 'gdfeitos_epoca';

export function EpocasProvider({ children }) {
  const [epocas, setEpocas] = useState([]);
  const [epocaSelecionada, setEpocaSelecionada] = useState('');
  const [loadingEpocas, setLoadingEpocas] = useState(true);

  useEffect(() => {
    let ativo = true;

    async function fetchEpocas() {
      try {
        const { data, error } = await supabase
          .from('Epocas')
          .select('Epoca')
          .order('Epoca', { ascending: true });

        if (error) throw error;
        if (!ativo) return;

        const lista = [...new Set((data || [])
          .map(item => String(item.Epoca || '').trim())
          .filter(Boolean))];

        setEpocas(lista);
        let guardada = '';
        try {
          guardada = window.localStorage.getItem(CHAVE_EPOCA) || '';
        } catch (erroStorage) {
          console.warn('Não foi possível ler a época guardada:', erroStorage);
        }

        setEpocaSelecionada(atual => {
          if (atual && lista.includes(atual)) return atual;
          return lista.includes(guardada) ? guardada : (lista[lista.length - 1] || '');
        });
      } catch (erro) {
        console.error('Erro ao carregar épocas:', erro);
        if (ativo) {
          setEpocas([]);
          setEpocaSelecionada('');
        }
      } finally {
        if (ativo) setLoadingEpocas(false);
      }
    }

    fetchEpocas();
    return () => { ativo = false; };
  }, []);

  useEffect(() => {
    if (!epocaSelecionada) return;
    try {
      window.localStorage.setItem(CHAVE_EPOCA, epocaSelecionada);
    } catch (erroStorage) {
      console.warn('Não foi possível guardar a época:', erroStorage);
    }
  }, [epocaSelecionada]);

  return (
    <EpocasContext.Provider value={{
      epocas,
      epocaSelecionada,
      setEpocaSelecionada,
      loadingEpocas
    }}>
      {children}
    </EpocasContext.Provider>
  );
}

export function useEpocasContext() {
  const context = useContext(EpocasContext);
  if (!context) {
    throw new Error('useEpocasContext tem de ser utilizado dentro de EpocasProvider');
  }
  return context;
}
